'use client';
import clsx from 'clsx';
import { useSatelliteContext } from '../../../components/SatelliteProvider';
import { useIsMounted } from '../../../hooks/useIsMounted';
import { AuthButtonSkeleton } from './AuthButtonSkeleton';
import { AuthButtonsLoggedOut } from './AuthButtonsLoggedOut';
import { AuthUrlProvider } from './AuthUrlsProvider';
import {
  AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
  AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
} from './constants';
import { MyNerdWalletMenu } from './MyNerdWalletMenu';
import { userHasIdToken } from './utils';

export function AuthButtons() {
  const {
    headerOptions: { enableAuthButtons },
  } = useSatelliteContext();
  const isMounted = useIsMounted();

  if (!enableAuthButtons) {
    return null;
  }

  const showMyNerdWalletMenu = userHasIdToken();

  return (
    <div
      className={clsx(
        'flex',
        'items-center',
        'justify-end',
        'box-border',
        AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
        AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
      )}
    >
      {!isMounted ? (
        <AuthButtonSkeleton />
      ) : (
        <AuthUrlProvider>
          {showMyNerdWalletMenu ? <MyNerdWalletMenu /> : <AuthButtonsLoggedOut />}
        </AuthUrlProvider>
      )}
    </div>
  );
}
